import { FilterViewApiService } from '@shared/services/filter-view-api.service';
import { PopoverHandlerConfig, PopoverConfig } from '../generic-popover.interfaces';
import { defaultCancelAction, defaultConfirmAction } from './default-actions';
import { FormConfig } from '@shared/components/edit-create-form';

export const filterViewPopoverConfig = (
  onSuccess: () => void,
  onCancel: () => void,
  hasSharedManagePermission: boolean,
  getCurrentFilterData: () => any,
  entityType: string,
  filterViewApiService: FilterViewApiService
): PopoverConfig => {

  const formConfig: FormConfig = {
    fields: [
      {
        key: 'id',
        label: 'ID',
        type: 'text',
        width: 'full',
        hidden: true
      },
      {
        key: 'name',
        label: 'Tên bộ lọc',
        type: 'text',
        width: 'full',
        required: true,
        placeholder: 'Nhập tên bộ lọc...'
      },
      {
        key: 'isShared',
        label: 'Chia sẻ với mọi người',
        type: 'checkbox',
        width: 'full',
        hidden: (editMode: boolean) => !hasSharedManagePermission || editMode,
        disabled: (editMode: boolean) => editMode
      }
    ]
  };

  return {
    width: '350px',
    title: 'Lưu bộ lọc mới',
    dismissable: true,
    formConfig,
    actions: [
      defaultCancelAction,
      { ...defaultConfirmAction, label: 'Lưu', icon: 'pi pi-save' }
    ],
    handlerConfig: {
      service: filterViewApiService,
      method: 'createFilterView',
      updateMethod: 'updateFilterView',
      entityLabel: 'bộ lọc',
      // For create mode: send all data including filterData
      commonDataTransform: (formValue: any) => ({
        name: formValue.name.trim(),
        entityType: entityType,
        filterData: getCurrentFilterData(),
        isShared: formValue.isShared || false,
        isPinned: false
      }),
      // For edit mode: only send id and name
      updateDataTransform: (formValue: any) => ({
        id: formValue.id,
        name: formValue.name.trim()
      }),
      initialDataTransform: (rawData: any) => ({
        id: rawData.id,
        name: rawData.name,
        isShared: rawData.isShared
      }),
      onSuccess,
      onCancel
    } as PopoverHandlerConfig
  };
};

